import { Spinner } from '@/components/ui';
import type { UserRole } from '@/types/types';
import type { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getDefaultPathForRole } from './redirects';
import { useAuth } from './useAuth';

interface ProtectedRouteProps {
  allowedRoles?: UserRole[];
  children?: ReactNode;
}

export function ProtectedRoute({ allowedRoles, children }: ProtectedRouteProps) {
  const { isAuthenticated, isValidating, user } = useAuth();

  if (isValidating) {
    return (
      <div className="grid place-items-center h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Guardar la ruta actual antes de redirigir al login
    const currentPath = window.location.pathname + window.location.search;
    sessionStorage.setItem('last_path', currentPath);
    return <Navigate to="/login" replace />;
  }

  // Validar roles si se especifican
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = user?.asesor?.rol as UserRole | undefined;
    if (!userRole) {
      return <Navigate to="/acceso-denegado" replace />;
    }

    if (!allowedRoles.includes(userRole)) {
      console.log('User Role:', userRole);
      console.log('Allowed Roles:', allowedRoles);

      const redirectTo = getDefaultPathForRole(userRole);
      return <Navigate to={redirectTo} replace />;
    }
  }

  return children ? <>{children}</> : <Outlet />;
}
